import { FileCheck, FileClock, Briefcase } from 'lucide-react';

interface MetricCardProps {
  icon: React.ReactNode;
  label: string;
  helper: string;
  count: number;
  tone: 'blue' | 'amber' | 'violet';
}

function MetricCard({ icon, label, helper, count, tone }: MetricCardProps) {
  return (
    <article className={`contractor-kpi contractor-kpi--${tone} bg-white border border-gray-200 rounded-xl p-4 transition-all duration-200`}>
      <div className="contractor-kpi__topline">
        <span className="contractor-kpi__label">{label}</span>
        <div className="contractor-kpi__icon p-3 rounded-lg bg-gray-50" aria-hidden="true">
          {icon}
        </div>
      </div>
      <div className="contractor-kpi__value text-2xl text-gray-900 tracking-tight">{count}</div>
      <div className="contractor-kpi__helper">{helper}</div>
    </article>
  );
}

interface SummaryCardsProps {
  live_projects?: number;
  contractor_sign_pending?: number;
  homeowner_sign_pending?: number;
}

export function SummaryCards({ 
  live_projects = 12, 
  contractor_sign_pending = 5, 
  homeowner_sign_pending = 8 
}: SummaryCardsProps) {
  const metrics = [
    {
      icon: <FileCheck className="w-5 h-5 text-gray-700" />,
      label: 'Live Contracts',
      helper: 'Active work in progress',
      count: live_projects,
      tone: 'blue' as const
    },
    {
      icon: <FileClock className="w-5 h-5 text-gray-700" />,
      label: 'Pending Signatures',
      helper: 'Waiting for your signature',
      count: contractor_sign_pending,
      tone: 'amber' as const
    },
    {
      icon: <Briefcase className="w-5 h-5 text-gray-700" />,
      label: 'Homeowners Pending Signatures',
      helper: 'Waiting for client approval',
      count: homeowner_sign_pending,
      tone: 'violet' as const
    }
  ];

  return (
    <div className="contractor-kpi-grid grid grid-cols-1 md:grid-cols-3 gap-4">
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          icon={metric.icon}
          label={metric.label}
          helper={metric.helper}
          count={metric.count}
          tone={metric.tone}
        />
      ))}
    </div>
  );
}
